import { render, staticRenderFns } from "./ChallengeForumTab.vue?vue&type=template&id=9675c2d2&scoped=true"
import script from "./ChallengeForumTab.vue?vue&type=script&lang=ts"
export * from "./ChallengeForumTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9675c2d2",
  null
  
)

export default component.exports